import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

import Resumen from '@/components/trackerSummary/trackerSummary'
import dishes from '@/components/trackerDishes/trackerDishes'

@Component({
  components: {
    Resumen,
    dishes
  }
})
export default class TrackerContentSummary extends Vue {
  @Getter getCurrentOrder
  @Getter getCountry

  get getTotal () {
    const price =  parseFloat(this.getCurrentOrder.total)
    return this.$currency.format(price, { code: this.getCountry.currency })
  }

  get getTotalTC() {
    const price = parseFloat(this.getCurrentOrder.total_us_donating)
    return this.$currency.format(price, { code: this.getCountry.currency })
  }

}
